import { DB, SQLBatchTuple } from "./index";
import time from "../time";
import log from "../log";
import { MessageType } from "../../src/constants/types";

// lbatchid是在新增的时候写入，用来解决消息空洞问题，如果是更新记录，则不修改lbatchid
// 所以ON CONFLICT(mid) DO UPDATE SET比insert少一个字段

// 'cid, tid, tmid, mid, sender,' +
// 'stime, type, content, meta, etime,' +
// 'target_cnt, target_uids, read_cnt, read_uids, at_cnt,' +
// 'at_uids, atread_cnt, atread_uids, mask, visible,' +
// 'audit_word,audit_word_tip, audit_rst, audit_mid, lbatchid, lutime,' +
// 'lctime, latme, send_statue,upload_statue,upload_path,
const insert_sql =
    "insert into t_msg(" +
    "uniqueId, mid, tid, tmid, cid, sender," +
    "stime, type, content, meta, etime," +
    "target_cnt, target_uids, read_cnt, read_uids, at_cnt," +
    "at_uids, atread_cnt, atread_uids, mask, visible," +
    "audit_word, audit_word_tip,audit_rst, audit_mid, lbatchid, lutime," +
    "lctime, latme,send_statue, upload_statue ,upload_path,thumbnailPath)" +
    " values(" +
    "?, ?, ?, ?, ?, ?," +
    "?, ?, ?, ?, ?," +
    "?, ?, ?, ?, ?," +
    "?, ?, ?, ?, ?," +
    "?, ?, ?, ?, ?," +
    "?, ?, ?, ?, ?, ?, ?)" +
    " ON CONFLICT(uniqueId) DO UPDATE SET " +
    "mid=?, tid=?, tmid=?, cid=?, sender=?," +
    "stime=?, type=?, content=?, meta=?, etime=?," +
    "target_cnt=?, target_uids=?, read_cnt=?, read_uids=?, at_cnt=?," +
    "at_uids=?, atread_cnt=?, atread_uids=?, mask=?, visible=?," +
    "audit_word=?, audit_word_tip=?, audit_rst=?, audit_mid=?, lutime=?, latme=?, send_statue=?, upload_statue=?;";

// 批量添加消息
export async function msg_batch_add(
    db: DB,
    uid: number, // 我是谁
    batchid: number,
    msgs: Msg[]
): Promise<{ error: any }> {
    let err: any = null;
    let insertCnt: number = 0;
    let updateCnt: number = 0;
    const n = msgs.length;
    const commands: SQLBatchTuple[] = [];
    for (let i = 0; i < n; i++) {
        const unixTime = time.toUnixMillSecond(time.now());
        let latme = 0; // 消息里有at自己
        if (msgs[i].atUids && msgs[i].atUids.length > 0) {
            const atIdx = msgs[i].atUids.indexOf(uid);
            if (atIdx >= 0 && atIdx < msgs[i].atUids.length) {
                latme = 1;
            }
        }
        const msg = msgs[i];
        const m = MsgToEntity(fixMsg(msg));
        const uniqueId = `${m.tid}-${m.cid}-${m.sender}`;
        const parms = [];
        // INSERT
        parms.push(...[uniqueId, m.mid, m.tid, m.tmid, m.cid, m.sender]); // 5
        parms.push(...[m.stime, m.type, m.content, m.meta, m.etime]); // 5
        parms.push(
            ...[m.target_cnt, m.target_uids, m.read_cnt, m.read_uids, m.at_cnt] // 5
        );
        parms.push(...[m.at_uids, m.atread_cnt, m.atread_uids, m.mask, m.visible]); // 5
        parms.push(...[m.audit_word, m.audit_word_tip, m.audit_rst, m.audit_mid, batchid, unixTime]); // 5
        parms.push(...[unixTime, latme, m.send_statue, m.upload_statue, m.upload_path, m.thumbnailPath]); // 1

        // CONFLICT
        parms.push(...[m.mid, m.tid, m.tmid, m.cid, m.sender]); // 2
        parms.push(...[m.stime, m.type, m.content, m.meta, m.etime]); // 5
        parms.push(
            ...[m.target_cnt, m.target_uids, m.read_cnt, m.read_uids, m.at_cnt] // 5
        );
        parms.push(...[m.at_uids, m.atread_cnt, m.atread_uids, m.mask, m.visible]); // 5
        parms.push(...[m.audit_word, m.audit_word_tip, m.audit_rst, m.audit_mid, unixTime, latme, m.send_statue, m.upload_statue]); // 4 没有批次
        // 执行
        commands.push([insert_sql, parms]);
        // const r = await db.Execute(insert_sql, parms);
        // if (r.error) {
        //     err = r.error;
        //     continue;
        // }
        // if (r.insertId > 0) {
        //     insertCnt++;
        // }
        // if (r.rowsAffected > 0) {
        //     updateCnt += r.rowsAffected;
        // }
    }

    const r = await db.BatchExecute(commands);
    log.info("msg_batch_add succ", "插入:", r.rowsAffected);

    // if (err) {
    //     log.warn(
    //         'msg_batch_add fail!',
    //         '插入:',
    //         insertCnt,
    //         '修改:',
    //         updateCnt,
    //         'err:',
    //         err,
    //     );
    // } else {
    //     log.info('msg_batch_add succ', '插入:', insertCnt, '修改:', updateCnt);
    // }

    return { error: err };
}

// 最近的那条消息
export async function msg_count(
    db: DB,
    tid: string,
    options: {
        expectSender?: number; // 排除发送用户
        atme?: boolean; // 是否At自己
        minMid?: string; // 最小的消息id
        mask?: number; // 消息状态
    }
): Promise<{ error: any; count?: number }> {
    const params = [];
    let sql = `select count(1) as cnt from t_msg where tid= ?`;
    params.push(tid);
    if (options.atme) {
        sql += " and latme=1";
    }
    if (options.minMid) {
        sql += ` and mid> ?`;
        params.push(options.minMid);
    }
    if (options.expectSender) {
        sql += ` and sender<> ?`;
        params.push(options.expectSender);
    }
    if (options.mask != undefined) {
        sql += ` and mask = ?`;
        params.push(options.mask);
    }
    sql += ` and visible = 0 `;
    const rst = await db.Query(sql, params);
    if (rst.error) {
        return { error: rst.error };
    }
    if (!(rst.data && rst.data.length > 0)) {
        return { error: null }; // 没有记录
    }

    return { error: null, count: rst.data[0].cnt };
}

export async function msg_clean(db: DB, tid: string): Promise<{ code: any }> {
    let sql = `delete from t_msg where tid=?`;
    const rst = await db.Execute(sql, [tid]);
    if (rst.rowsAffected > 0) {
        console.log("消息清空");
        return { code: 0 };
    }

    return { code: -1 };
}

export async function msg_clean_all(db: DB): Promise<{ code: any }> {
    let sql = `delete from t_msg `;
    const rst = await db.Execute(sql, []);
    if (rst.rowsAffected > 0) {
        console.log("消息清空");
        return { code: 0 };
    }

    return { code: -1 };
}

export async function qry_all_msg_tid(db: DB): Promise<{ code: any; tids?: { tid: string; mid: string }[] }> {
    let sql = `SELECT tid, MAX(mid) AS mid FROM t_msg WHERE mid IS NOT NULL AND mid <> '' GROUP BY tid`;
    // let sql = `SELECT tid, MAX(mid) AS mid FROM t_msg GROUP BY tid`

    const rst = await db.Query(sql, []);
    if (rst.data && rst.data.length > 0) {
        return { code: 0, tids: rst.data };
    }
    return { code: -1 };
}

export async function msg_del_by_cid(db: DB, tid: string, cid: number, sender: number, mid: string): Promise<{ code: any }> {
    const params = [cid, sender, tid];
    let sql = `delete from t_msg where cid = ? and sender = ? and tid = ?`;
    if (mid.length > 0) {
        params.push(mid);
        sql += ` and mid = ?`;
    }
    const rst = await db.Execute(sql, params);
    if (rst.rowsAffected > 0) {
        return { code: 0 };
    }
    return { code: -1 };
}

export async function msg_del(db: DB, tid: string, msgs: { mid: string; cid: number }[]): Promise<{ code: any }> {
    const n = msgs.length;
    let err: any;
    let count = 0;
    for (let i = 0; i < n; i++) {
        const { cid, mid } = msgs[i];
        let sql = `delete from t_msg where cid = ? and tid = ? and mid = ?`;
        const params = [cid, tid, mid];
        const r = await db.Execute(sql, params);
        if (r.error) {
            err = r.error;
            continue;
        }
        count++;
    }
    if (err) {
        return { code: -1 };
    } else {
        return { code: count };
    }
}

// 最近的那条消息
export async function msg_query_latest_one(
    db: DB,
    tid: string,
    options: {
        atme?: boolean; // 是否At自己
        minMid?: string; // 最小的消息id
        mask?: number; // 消息状态
        unequalMask?: boolean; // 消息状态
        isVisible?: boolean; //是否是所有人可见
    }
): Promise<{ error: any; msg?: Msg }> {
    const params: any = [tid];
    let sql = `select * from t_msg where tid= ?`;
    if (options.atme) {
        sql += " and latme=1";
    }
    if (options.minMid) {
        sql += ` and mid>? `;
        params.push(options.minMid);
    }
    if (options.mask !== undefined) {
        if (options.unequalMask && options.unequalMask) {
            sql += ` and mask <> ?`;
            params.push(options.mask);
        } else {
            sql += ` and mask = ?`;
            params.push(options.mask);
        }
    }
    if (options.isVisible) {
        sql += ` and visible = 0`;
    }
    sql += " order by cid desc LIMIT 1 OFFSET 0";
    const rst = await db.Query(sql, params);
    if (rst.error) {
        return { error: rst.error };
    }
    if (!(rst.data && rst.data.length > 0)) {
        return { error: null }; // 没有记录
    }
    const m = EntityToMsg(rst.data[0] as Entity);
    return { error: null, msg: m };
}

//获取前20个最新的 uid
export async function Query(
    db: DB,
    search: string,
    time: number,
    tids?: string[]
): Promise<{ error: any; data?: { tid: string; total: number }[] }> {
    const params: any[] = [time];
    // let sql = 'SELECT DISTINCT tid FROM t_msg WHERE'
    // sql += ` cid<=? AND type='txt' AND LOWER(content) LIKE '%?%'`
    let sql = "SELECT DISTINCT tid FROM t_msg WHERE cid<=? AND ( (type = 'txt' AND LOWER(content) LIKE ?) OR (type = 'doc' AND LOWER(meta) LIKE ?) )";
    params.push(`%${search}%`);
    params.push(`%${search}%`);
    if (tids && tids.length > 0) {
        const placeholders = tids.map(() => "?").join(", ");
        params.push(...tids);
        sql += ` AND tid NOT IN (${placeholders})`;
    }
    sql += " ORDER BY cid DESC LIMIT 20";
    const rst = await db.Query(sql, params);
    if (rst.error) {
        return { error: rst.error };
    }
    if (!(rst.data && rst.data.length > 0)) {
        return { error: null }; // 没有记录
    }
    const data: { tid: string; total: number }[] = [];
    const pr: Promise<any>[] = [];
    rst.data.forEach((v) => {
        pr.push(QueryTotal(db, v.tid, search));
    });
    const r = await Promise.all(pr);
    r.forEach((v) => {
        if (v.data) {
            data.push(v.data);
        }
    });
    return { error: null, data: data };
}

export async function QueryTotal(db: DB, tid: string, search: string): Promise<{ error: any; data?: { tid: string; total: number } }> {
    const params = [tid, `%${search.toLowerCase()}%`, `%${search.toLowerCase()}%`];
    const sql = `SELECT COUNT(*) AS total FROM t_msg  WHERE tid = ? AND ( (type = 'txt' AND LOWER(content) LIKE ?) OR (type = 'doc' AND LOWER(meta) LIKE ?) );`;
    const rst = await db.Query(sql, params);
    if (rst.error) {
        return { error: rst.error };
    }
    if (!(rst.data && rst.data.length > 0)) {
        return { error: null }; // 没有记录
    }
    const total = rst.data[0].total;
    return { error: null, data: { tid, total } };
}

// 查一个消息
export async function msg_query_one(db: DB, mid: string): Promise<{ error: any; msg?: Msg }> {
    const sql = `select * from t_msg where mid=? limit 1`;
    // const params = [];
    const rst = await db.Query(sql, [mid]);
    if (rst.error) {
        return { error: rst.error };
    }
    if (!(rst.data && rst.data.length > 0)) {
        return { error: null }; // 没有记录
    }
    const m = EntityToMsg(rst.data[0]);
    return { error: null, msg: m };
}

export type MsgQryCond = {
    tid: string; // 会话，必填
    mid?: string; // 指定mid
    contain?: boolean; // 指定mid
    rangeMinMid?: string; // 没设置就是无穷小
    cid?: number; // 没设置就是无穷小
    maxCid?: number;
    containMinMid?: boolean; // 是否包含最小消息Id，sql里表现就是大于等于
    rangeMaxMid?: string; // 没设置就是无穷大
    containMaxMid?: boolean; // 是否包含最大消息Id，sql里表现就是小于等于
    order?: string; // asc - 升序 desc - 降序 按消息id排序，默认降序
    limit?: number; // 0-不限制 小于0或无设置-默认100条
};

export type MsgSearchCond = {
    tid: string;
    page: number;
    mask?: number;
    type?: MessageType[]; //按消息类型查找
    searchVal?: string;
    sender?: number; //按成员查找
    date?: number; //按时间查找
};
const getMinMaxTimestamps = (date: number): { minTimestamp: number; maxTimestamp: number } => {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0); // 设置为当天 00:00:00
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999); // 设置为当天 23:59:59

    return {
        minTimestamp: startOfDay.getTime(), // 返回毫秒级的时间戳
        maxTimestamp: endOfDay.getTime(), // 返回毫秒级的时间戳
    };
};

// 根据条件查询消息
export async function msg_search(db: DB, cond: MsgSearchCond): Promise<{ error: any; msgs?: Msg[] }> {
    const { tid, page, type, searchVal, sender, date, mask } = cond;
    const pageSize = 50;
    const offset = page * pageSize;
    const params: any[] = [tid, mask];

    let sql = `SELECT * FROM t_msg WHERE tid = ? AND mask = ?`;

    // 条件拼接
    if (type && type.length > 0) {
        const placeholders = type.map(() => '?').join(','); // 生成 "?,?"
        sql += ` AND type IN (${placeholders})`;
        params.push(...type);      // 展开数组，逐个加入参数
    }

    if (searchVal && searchVal.length > 0) {
        sql += ` AND content LIKE ? OR LOWER(meta) LIKE ?`;
        params.push(`%${searchVal}%`);
        params.push(`%${searchVal}%`);
    }

    if (sender) {
        sql += ` AND sender = ?`;
        params.push(sender);
    }

    if (date) {
        const { minTimestamp, maxTimestamp } = getMinMaxTimestamps(date);
        sql += ` AND stime BETWEEN ? AND ?`;
        params.push(minTimestamp, maxTimestamp);
    }

    // 排序与分页
    sql += ` ORDER BY stime DESC LIMIT ?, ?`;
    params.push(offset, pageSize);

    const r = await db.Query(sql, params);
    if (r.error) {
        return { error: r.error };
    }

    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }

    const d: Entity[] = r.data as Entity[];
    const n = d.length;
    const msgs: Msg[] = [];
    for (let i = 0; i < n; i++) {
        msgs.push(EntityToMsg(d[i]));
    }
    return { error: null, msgs: msgs };
}

//查找发送状态为发送中的消息
export async function qry_sending_msg(db: DB, tid: string, cid: number, sender: number): Promise<{ error: any; msgs?: Msg[] }> {
    let sql = `select * from t_msg where tid = ?`;
    sql += ` and cid = ? `;
    sql += ` and sender = ? `;
    sql += ` and send_statue = ? `;
    const r = await db.Query(sql, [tid, cid, sender, "0"]);
    if (r.error) {
        return { error: r.error };
    }

    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }

    const d: Entity[] = r.data as Entity[];
    const n = d.length;
    const msgs: Msg[] = [];
    for (let i = 0; i < n; i++) {
        msgs.push(EntityToMsg(d[i]));
    }
    return { error: null, msgs: msgs };
}
export async function msg_query_last_mid(db: DB, tid: string): Promise<{ error?: any; mid?: string }> {
    let sql = `SELECT mid FROM t_msg WHERE tid=? AND mid IS NOT NULL AND mid != '' LIMIT 1;`;
    const r = await db.Query(sql, [tid]);
    if (r.data && r.data.length > 0) {
        return { mid: r.data[0].mid };
    }
    return { error: r.error };
}

/** 检查一批 mid 是否存在任意一条（用于消息桥接 overlap 判断） */
export async function msg_exists_any_mid(
    db: DB,
    tid: string,
    mids: string[],
): Promise<{ error: any; exists: boolean }> {
    const uniqMids = [...new Set((mids || []).filter((v) => !!v && v.length > 0))];
    if (uniqMids.length === 0) {
        return { error: null, exists: false };
    }
    const placeholders = uniqMids.map(() => '?').join(', ');
    const sql = `SELECT 1 FROM t_msg WHERE tid = ? AND mid IN (${placeholders}) LIMIT 1`;
    const r = await db.Query(sql, [tid, ...uniqMids]);
    if (r.error) {
        return { error: r.error, exists: false };
    }
    return { error: null, exists: !!(r.data && r.data.length > 0) };
}
// 根据条件查询消息
export async function msg_query(db: DB, cond: MsgQryCond): Promise<{ error: any; msgs?: Msg[] }> {
    const params: any[] = [];
    let sql = `select * from t_msg where tid=?`;
    params.push(cond.tid);
    // sql += ` AND visible != ?`;
    // params.push(-2);
    if (cond.mid) {
        sql += ` AND mid = ?`;
        params.push(cond.mid);
    }
    if (cond.rangeMinMid) {
        if (cond.containMinMid) {
            sql += ` AND mid >= ?`;
        } else {
            sql += ` AND mid > ?`;
        }
        params.push(cond.rangeMinMid);
    }
    if (cond.rangeMaxMid) {
        if (cond.containMaxMid) {
            sql += ` AND mid <= ?`;
        } else {
            sql += ` AND mid < ?`;
        }
        params.push(cond.rangeMaxMid);
    }
    if (cond.cid) {
        if (cond.contain) {
            sql += ` AND cid >= ?`;
        } else {
            sql += ` AND cid > ?`;
        }
        params.push(cond.cid);
    }
    if (cond.maxCid) {
        if (cond.contain) {
            sql += ` AND cid <= ?`;
        } else {
            sql += ` AND cid < ?`;
        }
        params.push(cond.maxCid);
    }

    if (cond.order && cond.order === "asc") {
        sql += " order by stime asc";
    } else {
        sql += " order by stime desc";
    }

    // if (cond.order && cond.order === "asc") {
    //     sql += " order by mid asc";
    // } else {
    //     sql += " order by mid desc";
    // }

    if (cond.limit === 0) {
        // 不加 limit
    } else if (cond.limit && cond.limit > 0) {
        sql += ` LIMIT ?`;
        params.push(cond.limit);
    } else {
        sql += ` LIMIT 100`;
    }

    const r = await db.Query(sql, params);
    if (r.error) {
        return { error: r.error };
    }

    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }

    const d: Entity[] = r.data as Entity[];
    const n = d.length;
    const msgs: Msg[] = [];

    for (let i = 0; i < n; i++) {
        msgs.push(EntityToMsg(d[i]));
    }
    return { error: null, msgs: msgs };
}

// 消息的状态先来 消息实体还没到
export async function msg_update_stat(db: DB, msg: Msg, meta: Meta): Promise<{ error: any }> {
    const m = fixMsg(msg);
    const unixTime = time.toUnixMillSecond(time.now());
    let sql = "update t_msg set" + " target_cnt=?, read_cnt=?, at_cnt=?, atread_cnt=?, mask=?," + " visible=?, audit_rst=?, lutime=?";
    const params: any[] = [m.targetCnt, m.readCnt, m.atCnt, m.atReadCnt, m.mask, m.visible, m.auditRst, unixTime];
    const isRTC = msg.type === MessageType.RTC_VIDEO || msg.type === MessageType.RTC_VOICE;
    if (isRTC) {
        sql += ", meta=?";
        params.push(JSON.stringify(meta));
    }
    sql += " where mid=?";
    params.push(m.mid);
    const rst = await db.Execute(sql, params);
    return { error: rst.error };
}

export async function msg_update_meta(db: DB, mid: string, meta: Meta): Promise<{ error: any }> {
    const sql = "update t_msg set meta=? where mid=?";
    const rst = await db.Execute(sql, [JSON.stringify(meta), mid]);
    return { error: rst.error };
}

// 更新占位图
export async function msg_update_thumbnailPath(db: DB, mid: string, thumbnailPath: string): Promise<{ error: any }> {
    if (thumbnailPath.length == 0) {
        return { error: null };
    }

    const sql = "update t_msg set thumbnailPath=? where mid=?";
    const rst = await db.Execute(sql, [thumbnailPath, mid]);
    return { error: rst.error };
}

// projection := bson.M{
//     "_id":       1,
//         "tid":       1,
//         "sender":    1,
//         "targetCnt": 1, // 目标用户数
//         "readCnt":   1, // 目标已读用户数
//         "atCnt":     1, // at用户数
//         "atReadCnt": 1, // at已读用户数
//         "mask":      1,
//         "visible":   1,
//         "auditRst":  1,
// }
//
// if detail {
//     projection["targetUids"] = 1 // 目标用户列表
//     projection["readUids"] = 1   // 目标已读用户列表
//     projection["atUids"] = 1     // at用户列表
//     projection["atReadUids"] = 1 // at已读用户列表
// }

// 数据库记录到Msg实体转换
function EntityToMsg(d: Entity): Msg {
    return {
        mid: d.mid, // 由 topicid? 拼接而成 保证唯一
        tid: d.tid, // TopidId：g_topicid s_sys_userid 通过topicid的前缀 g_ s_ 区分单聊和群聊 系统给用户自动创建的会话;单聊是两个用户id排序后组合；
        tmid: d.tmid, // 会话单独的msgid
        cid: d.cid, // 客户端生成的唯一的消息Id，用于客户端消息去重
        sender: d.sender, // 发送方
        stime: d.stime, // 发送时间 单位毫秒
        type: d.type, // 消息类型
        content: d.content, // 消息正文内容
        meta: JSON.parse(d.meta), // map[string]string meta，消息属性客户端自行设置
        etime: d.etime, // 失效时间，过了这个时间消息批量拉取时跳过，单拉还是可以查询到，用于有时效的消息
        targetCnt: d.target_cnt, // 目标用户数
        targetUids: JSON.parse(d.target_uids), // 目标用户列表 []int64
        readCnt: d.read_cnt, // 已读的数量
        readUids: JSON.parse(d.read_uids), //  []int64  已读用户列表
        atCnt: d.at_cnt, // 这条消息被@的人数量
        atUids: JSON.parse(d.at_uids), //  []int64 这条消息被@的人列表
        atReadCnt: d.atread_cnt, // 这条消息被@的人已读数量
        atReadUids: JSON.parse(d.atread_uids), // []int64   这条消息被@的人已读列表
        mask: d.mask, // 0-正常 1-删除 2-撤回
        visible: d.visible, // 0-正常所有人可见 1-发送者和群管理可见
        auditWord: d.audit_word, // 需要审核的敏感词 json序列化会自动去掉为空时的字段
        auditWordTip: d.audit_word_tip, //敏感词提示内容
        auditRst: d.audit_rst, // 空-无操作 pass - 允许 refused - 拒绝 json序列化会自动去掉为空的字段
        auditMid: d.audit_mid, // 审核通过后的消息id
        lbatchid: d.lbatchid, // 批次，解决消息空洞问题
        lutime: d.lutime, // 本地，记录最后的修改时间
        lctime: d.lctime, // 本地，记录创建时间
        encrypt: d.encrypt,
        send_statue: d.send_statue,
        upload_statue: d.upload_statue,
        upload_path: d.upload_path,
        thumbnailPath: d.thumbnailPath,
    };
}

// 消息转换为数据库存储的结构
export function MsgToEntity(m: Msg): Entity {
    return {
        mid: m.mid,
        tid: m.tid,
        tmid: m.tmid,
        cid: m.cid,
        sender: m.sender,
        stime: m.stime,
        type: m.type,
        content: m.content,
        meta: JSON.stringify(m.meta),
        etime: m.etime,
        target_cnt: m.targetCnt,
        target_uids: JSON.stringify(m.targetUids),
        read_cnt: m.readCnt,
        read_uids: JSON.stringify(m.readUids),
        at_cnt: m.atCnt,
        at_uids: JSON.stringify(m.atUids),
        atread_cnt: m.atReadCnt,
        atread_uids: JSON.stringify(m.atReadUids),
        mask: m.mask,
        visible: m.visible,
        audit_word: m.auditWord,
        audit_word_tip: m.auditWordTip,

        audit_rst: m.auditRst,
        audit_mid: m.auditMid,
        lbatchid: m.lbatchid,
        lutime: m.lutime,
        lctime: m.lctime,
        encrypt: m.encrypt,
        send_statue: m.send_statue,
        upload_statue: m.upload_statue,
        upload_path: m.upload_path,
        thumbnailPath: m.thumbnailPath, //视频缩略图
    };
}

type Entity = {
    mid: string;
    tid: string;
    tmid: number;
    cid: number;
    sender: number;
    stime: number;
    type: string;
    content: string;
    meta: string;
    etime: number;
    target_cnt: number;
    target_uids: string;
    read_cnt: number;
    read_uids: string;
    at_cnt: number;
    at_uids: string;
    atread_cnt: number;
    atread_uids: string;
    mask: number;
    visible: number;
    encrypt: number;
    audit_word: string;
    audit_word_tip: string;
    audit_rst: string;
    audit_mid: string;
    lbatchid: number;
    lutime: number;
    lctime: number;
    send_statue: string;
    upload_statue: string;
    upload_path: string;
    thumbnailPath: string; //视频缩略图
    rtcId?: string | number;
    duration?: number;
};

// 防止undefined字段
export function fixMsg(dao: Msg): Msg {
    if (typeof dao.cid === "string") {
        dao.cid = Number(dao.cid);
    }
    return Object.assign({}, defaultMsgDao, dao);
}

export type Meta = { [key: string]: any };

// 消息有哪些字段 就是最原始的消息
export type Msg = {
    mid: string; // 由 topicid? 拼接而成 保证唯一
    tid: string; // TopidId：g_topicid s_sys_userid 通过topicid的前缀 g_ s_ 区分单聊和群聊 系统给用户自动创建的会话;单聊是两个用户id排序后组合；
    tmid: number; // 会话单独的msgid
    cid: number; // 客户端生成的唯一的消息Id，用于客户端消息去重
    sender: number; // 发送方
    stime: number; // 发送时间 单位毫秒
    type: string; // 消息类型
    content: string; // 消息正文内容
    meta: Meta; // map[string]string meta，消息属性客户端自行设置
    etime: number; // 失效时间，过了这个时间消息批量拉取时跳过，单拉还是可以查询到，用于有时效的消息
    targetCnt: number; // 目标用户数
    targetUids: number[]; // 目标用户列表 []int64
    readCnt: number; // 已读的数量
    readUids: number[]; //  []int64  已读用户列表
    atCnt: number; // 这条消息被@的人数量
    atUids: number[]; //  []int64 这条消息被@的人列表
    atReadCnt: number; // 这条消息被@的人已读数量
    atReadUids: number[]; // []int64   这条消息被@的人已读列表
    mask: number; // 0-正常 1-删除 2-撤回
    visible: number; // 0-正常所有人可见 1-发送者和群管理可见
    auditWord: string; // 需要审核的敏感词 json序列化会自动去掉为空时的字段
    auditWordTip: string; //敏感词提示内容
    auditRst: string; // 空-无操作 pass - 允许 refused - 拒绝 json序列化会自动去掉为空的字段
    auditMid: string; // 审核通过后的消息id
    encrypt: number; // 是否加密

    // 下面定义本地的字段，l打头
    lbatchid: number; // 批次，解决消息空洞问题
    lutime: number; // 本地，记录最后的修改时间
    lctime: number; // 本地，记录创建时间

    send_statue: string; //发送状态 0 发送中，1：发送失败。其他发送成功
    upload_statue: string; //上传状态 0 上传中，1：上传失败。其他上传成功
    upload_path: string; //上传图片/视频 本地路径
    thumbnailPath: string; //视频缩略图
    rtcId?: string | number;
    duration?: number;
};

export const defaultMsgDao: Msg = {
    mid: "", // 由 topicid? 拼接而成 保证唯一
    tid: "", // TopidId：g_topicid s_sys_userid 通过topicid的前缀 g_ s_ 区分单聊和群聊 系统给用户自动创建的会话;单聊是两个用户id排序后组合；
    tmid: 0, // 会话单独的msgid
    cid: 0, // 客户端生成的唯一的消息Id，用于客户端消息去重
    sender: 0, // 发送方
    stime: 0, // 发送时间 单位毫秒
    encrypt: 0, //
    type: "", // 消息类型
    content: "", // 消息正文内容
    meta: {}, // map[string]string meta，消息属性客户端自行设置
    etime: 0, // 失效时间，过了这个时间消息批量拉取时跳过，单拉还是可以查询到，用于有时效的消息
    targetCnt: 0, // 目标用户数
    targetUids: [], // 目标用户列表 []int64
    readCnt: 0, // 已读的数量
    readUids: [], //  []int64  已读用户列表
    atCnt: 0, // 这条消息被@的人数量
    atUids: [], //  []int64 这条消息被@的人列表
    atReadCnt: 0, // 这条消息被@的人已读数量
    atReadUids: [], // []int64   这条消息被@的人已读列表
    mask: 0, // 0-正常 1-删除 2-撤回
    visible: 0, // 0-正常所有人可见 1-发送者和群管理可见
    auditWord: "", // 需要审核的敏感词 json序列化会自动去掉为空时的字段
    auditWordTip: "",
    auditRst: "", // 空-无操作 pass - 允许 refused - 拒绝 json序列化会自动去掉为空的字段
    auditMid: "", // 审核通过后的消息id
    // 下面定义本地的字段，l打头
    lbatchid: 0, // 批次，解决消息空洞问题
    lutime: 0, // 本地，记录最后的修改时间
    lctime: 0, // 本地，记录创建时间
    send_statue: "", //发送状态 0 发送中，1：发送失败。其他发送成功
    upload_statue: "", //上传状态 0 上传中，1：上传失败。其他上传成功
    upload_path: "", //图片/视频 本地路径
    thumbnailPath: "", //视频缩略图
    rtcId: "",
    duration: 0,
};

export type RTCContent = {
    rtcId?: string;
    duration?: number;
    memberList?: [{ userId: number; status: number }];
    status?: number; // 状态 -1:canceled  0:pending(初始状态)  1:ready(已经达到可以发起对话的标准即 有2人以上加入)  2:started (已经有2人已经连入了) 3:done(全都退了)
};
